import React from "react";
import {
  Box,
  Typography,
  Drawer,
  List,
  ListItem,
  Button,
  Divider,
  Snackbar,
  Alert,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Facebook, Twitter, Instagram, LinkedIn, YouTube, WhatsApp, Language } from "@mui/icons-material";


const CartAndFooter = ({
  drawerOpen,
  onDrawerClose,
  cart,
  IMAGE_BASE_URL,
  placeholderImage,
  confirming,
  onConfirmOrder,
  showSuccessMsg,
  onSuccessMsgClose,
  socialLinks,
  getSocialIcon,
  getSocialColor,
  isMobile,
}) => {
  return (
    <>
      {/* السلة */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={onDrawerClose}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 400 },
            bgcolor: "#fff",
            borderTopLeftRadius: { xs: 0, sm: 32 },
            borderBottomLeftRadius: { xs: 0, sm: 32 },
            boxShadow: "0 8px 32px 0 rgba(255,61,61,0.15)",
            border: "2px solid #ffb30022",
          },
        }}
      >
        <Box
          sx={{
            p: 0,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fffbe6",
          }}
        >
          <Box
            sx={{
              px: { xs: 2, sm: 4 },
              pt: { xs: 2, sm: 4 },
              pb: { xs: 1.5, sm: 2 },
              borderBottom: "2px solid #ffe0b2",
              bgcolor: "#fffbe6",
              borderTopLeftRadius: { xs: 0, sm: 32 },
              borderTopRightRadius: { xs: 0, sm: 32 },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 900,
                color: "#ff3d3d",
                letterSpacing: 2,
                fontSize: { xs: 22, sm: 26, md: 28 },
              }}
            >
              🛒 السلة
            </Typography>
            <IconButton
              onClick={onDrawerClose}
              sx={{
                color: "#ff3d3d",
                bgcolor: "#fff",
                border: "2px solid #ffe0b2",
                width: { xs: 36, sm: 40 },
                height: { xs: 36, sm: 40 },
                transition: "all 0.2s",
                "&:hover": {
                  bgcolor: "#ff3d3d",
                  borderColor: "#ff3d3d",
                  color: "#fff",
                  transform: "scale(1.1)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 0 }} />
          {cart.length > 0 ? (
            <List sx={{ 
              flexGrow: 1, 
              px: { xs: 1.5, sm: 2 }, 
              py: { xs: 1.5, sm: 2 }, 
              bgcolor: "#fffbe6",
              overflowY: "auto",
            }}>
              {cart.map((item, index) => (
                <ListItem
                  key={index}
                  sx={{
                    mb: { xs: 1.5, sm: 2 },
                    bgcolor: "#fff",
                    borderRadius: { xs: 2, sm: 3 },
                    boxShadow: "0 2px 8px 0 #ffb30022",
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: 1, sm: 2 },
                    px: { xs: 1, sm: 1.5 },
                    py: { xs: 1, sm: 1.5 },
                    border: "1.5px solid #ffe0b2",
                    flexDirection: "column",
                    alignItems: "stretch",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 }, mb: item.note ? 1 : 0 }}>
                    <Box
                      sx={{
                        width: { xs: 48, sm: 54 },
                        height: { xs: 48, sm: 54 },
                        borderRadius: 2,
                        overflow: "hidden",
                        boxShadow: "0 2px 8px 0 #ffb30022",
                        bgcolor: "#fff",
                        border: "1.5px solid #ffb30033",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={item.image ? `${IMAGE_BASE_URL}${item.image}` : placeholderImage}
                        alt={item.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 8,
                          display: "block",
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography
                        sx={{
                          fontWeight: 800,
                          fontSize: { xs: 14, sm: 16 },
                          color: "#181c2f",
                          mb: 0.5,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#888",
                          fontWeight: 500,
                          fontSize: { xs: 12, sm: 13 },
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.description}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#ffb300",
                          fontWeight: 700,
                          fontSize: { xs: 12, sm: 13 },
                          mt: 0.5,
                        }}
                      >
                        الكمية: {item.quantity || 1}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        minWidth: { xs: 60, sm: 70 },
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{ 
                          color: "#ffb300", 
                          fontWeight: 700, 
                          fontSize: { xs: 14, sm: 15 } 
                        }}
                      >
                        {(item.price * (item.quantity || 1)).toFixed(2)} ج.م
                      </Typography>
                    </Box>
                  </Box>
                  {item.note && (
                    <Box
                      sx={{
                        bgcolor: "#fffef5",
                        borderRadius: 1.5,
                        p: 1,
                        border: "1px solid #ffe0b2",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 11, sm: 12 },
                          color: "#666",
                          fontStyle: "italic",
                        }}
                      >
                        📝 {item.note}
                      </Typography>
                    </Box>
                  )}
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography
              sx={{ 
                color: "#888", 
                mt: 6, 
                textAlign: "center", 
                fontSize: { xs: 16, sm: 18 } 
              }}
            >
              السلة فارغة
            </Typography>
          )}
          {cart.length > 0 && (
            <Box
              sx={{
                px: { xs: 2, sm: 4 },
                pb: { xs: 2, sm: 3 },
                pt: { xs: 1.5, sm: 2 },
                borderTop: "2px solid #ffe0b2",
                bgcolor: "#fffbe6",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#ffb300",
                  color: "#fff",
                  fontWeight: 900,
                  fontSize: { xs: 16, sm: 18, md: 20 },
                  borderRadius: { xs: 2, sm: 3 },
                  py: { xs: 1.2, sm: 1.5 },
                  mt: 1,
                  boxShadow: "0 2px 12px 0 rgba(255,179,0,0.13)",
                  "&:hover": { bgcolor: "#ff3d3d" },
                }}
                fullWidth
                onClick={onConfirmOrder}
                disabled={confirming}
              >
                {confirming ? "جاري تأكيد الطلب..." : "✅ تأكيد الطلب"}
              </Button>
            </Box>
          )}
        </Box>
      </Drawer>

      {/* رسالة نجاح */}
      <Snackbar
        open={showSuccessMsg}
        autoHideDuration={4000}
        onClose={onSuccessMsgClose}
        anchorOrigin={{ 
          vertical: isMobile ? "top" : "top", 
          horizontal: "center" 
        }}
      >
        <Alert
          severity="success"
          sx={{
            fontSize: { xs: 14, sm: 16, md: 18 },
            fontWeight: "bold",
            bgcolor: "#fffbe6",
            color: "#d32f2f",
            borderRadius: 2,
            boxShadow: "0 2px 12px #d32f2f22",
            textAlign: "center",
            px: { xs: 2, sm: 3 },
            py: { xs: 1.5, sm: 2 },
            maxWidth: { xs: "90%", sm: "auto" },
          }}
        >
          {isMobile 
            ? "شكراً! سيتم تحضير طلبك 🚀"
            : "شكراً لكم! سوف يتم مراجعة أوردرِكم وتحضيره في أسرع وقت 🚀"
          }
        </Alert>
      </Snackbar>

      {/* Social Media Links */}
      {socialLinks.length > 0 && (
        <Box
          sx={{
            width: "100%",
            px: { xs: 2, sm: 4 },
            mt: { xs: 3, sm: 4 },
            mb: { xs: 2, sm: 3 },
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1rem", sm: "1.1rem" },
              color: "#ff3d3d",
            }}
          >
            تابعنا على
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: { xs: 1.5, sm: 2 },
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {socialLinks.map((link) => (
              <Tooltip key={link.id} title={link.name_ar} arrow>
                <IconButton
                  component="a"
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    bgcolor: `${getSocialColor(link.type)}15`,
                    color: getSocialColor(link.type),
                    width: { xs: 48, sm: 56 },
                    height: { xs: 48, sm: 56 },
                    transition: "all 0.3s ease",
                    "&:hover": {
                      bgcolor: getSocialColor(link.type),
                      color: "#fff",
                      transform: "translateY(-4px)",
                      boxShadow: `0 8px 16px ${getSocialColor(link.type)}40`,
                    },
                  }}
                >
                  {getSocialIcon(link.type)}
                </IconButton>
              </Tooltip>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default CartAndFooter;
